module.exports = __webpack_public_path__ + "static/img/banner.4bf6d7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/banner.png
// module id = NbjE
// module chunks = 1